module.exports = __webpack_public_path__ + "8fda3d18e335206c67681fde4cf93d23.jpeg";